/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: block;
}

:host > div.label {
  line-height: calc(36rem/14);
  padding-left: calc(8rem/14);
  font-size: calc(14rem/14);
  font-weight: bold;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}

:host([hidden]) {
  display: none;
}`;
export { style };
